export enum FieldGroupSubType {
    Other = 0,
    EighthGrade = 8,
    Freshman = 9,
    Sophomore = 10,
    Junior = 11,
    Senior = 12,
    GeneralSportStats = 13
}